"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processOrder = void 0;
const helpers_1 = require("../../helpers");
const getOrderById_1 = require("./getOrderById");
const sendEmail_1 = require("../sendEmail");
const updateOrderStatus_1 = require("./updateOrderStatus");
const allHotelOrderLinesConfirmed_1 = require("./allHotelOrderLinesConfirmed");
const __1 = require("..");
const processOrder = async (supabase, order_obj, old_order_obj, context) => {
    const order = await (0, getOrderById_1.getOrderById)(supabase, order_obj.id);
    const order_lines = order.order_lines;
    // only process if the order status has changed between the old and new order
    if (old_order_obj.status === order_obj.status)
        return;
    switch (order.status) {
        case helpers_1.OrderStatus.CONFIRMED: {
            // if order is confirmed we can send the voucher email to the customer
            if (!order_lines)
                return;
            const voucher_email = {
                language_code: "en",
                template_id: helpers_1.EMAIL_VOUCHERS,
                order_id: order.id,
            };
            // Send email to customer
            await (0, sendEmail_1.sendEmail)(voucher_email);
            await (0, __1.scheduleOrderEmails)(supabase, order_obj.id);
            break;
        }
        case helpers_1.OrderStatus.QUOTE_SENT: {
            if (old_order_obj.status === helpers_1.OrderStatus.UNSAVED) {
                const quote_accepted_email = {
                    language_code: "en",
                    template_id: helpers_1.EMAIL_NEW_QUOTE_B2B_NOTIFICATION,
                    order_id: order.id,
                    data: {
                        agent_user_first_name: order?.created_by_user?.first_name,
                        agent_user_last_name: order?.created_by_user?.last_name,
                    },
                    cc_address: ["simon@golfsavers.com", "peter@golfb2b.com"], // if a quote has been accepted then the default variant is the accepted variant
                };
                // Send email to customer
                await (0, sendEmail_1.sendEmail)(quote_accepted_email);
            }
            break;
        }
        case helpers_1.OrderStatus.READY_FOR_WORKFLOW: {
            // Quote has been accepted and is now ready for workflow
            if (!order_lines)
                return;
            const accepted_quote = order.quotes?.find((quote) => {
                return quote.accepted_date !== null;
            });
            // if there is no accepted quote found, don't send an email.
            if (!accepted_quote)
                return;
            const quote_accepted_email = {
                language_code: "en",
                template_id: helpers_1.EMAIL_CLIENT_QUOTE_ACCEPTED_NOTIFICATION,
                order_id: order.id,
                cc_address: ["simon@golfsavers.com", "david@golfsavers.com"],
                order_variant_id: order.default_variant_id, // if a quote has been accepted then the default variant is the accepted variant
            };
            // Send email to customer
            await (0, sendEmail_1.sendEmail)(quote_accepted_email);
            break;
        }
        case helpers_1.OrderStatus.CONFIRMING_HOTELS: {
            if (!order)
                return;
            // if we're in this status then the order has been confirmed and is now ready for workflow.  Get the variant that has been confirmed
            const variant_id = order.default_variant_id;
            const variant = order?.variants?.find((v) => v.id === variant_id);
            if (!variant) {
                context.log("No variant found for order", order.id);
                return;
            }
            const has_hotel = variant?.order_lines?.some((line) => line.type === "HOTEL");
            const all_hotels_confirmed = (0, allHotelOrderLinesConfirmed_1.allHotelOrderLinesConfirmed)(order);
            if (!has_hotel || (has_hotel && all_hotels_confirmed)) {
                context.log("No hotel found for order", order.id);
                // if no hotel is found we can update the order status to CONFIRMING_GOLF
                await (0, updateOrderStatus_1.updateOrderStatus)(supabase, order, "CONFIRMING_GOLF");
            }
            break;
        }
        case helpers_1.OrderStatus.QUOTE_EXPIRING: {
            if (!order_lines)
                return;
            context.log("Order is expiring soon");
            // Send email to client to remind them that the quote is expiring soon
            break;
        }
        case helpers_1.OrderStatus.QUOTE_EXPIRED: {
            if (!order_lines)
                return;
            context.log("Order has expired");
            // Send email to client to inform them that the quote has expired
            break;
        }
        case helpers_1.OrderStatus.CANCELLED: {
            // if the order is cancelled, send an email to support to inform them of the cancellation (only if b2b)
            if (order.source === "GOLFB2B") {
                // SEND EMAIL
                const b2b_order_cancelled_email = {
                    language_code: "en",
                    template_id: helpers_1.B2B_ORDER_CANCELLED,
                    order_id: order.id,
                    data: {
                        agent_user_first_name: order?.created_by_user?.first_name,
                        agent_user_last_name: order?.created_by_user?.last_name,
                    },
                    cc_address: ["simon@golfsavers.com", "pete@golfb2b.com"],
                };
                // Send email to customer
                await (0, sendEmail_1.sendEmail)(b2b_order_cancelled_email);
            }
        }
    }
};
exports.processOrder = processOrder;
